import script from "./EditableLevelGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditableLevelGroup.vue?vue&type=script&setup=true&lang=ts"

import "./EditableLevelGroup.vue?vue&type=style&index=0&id=ada13f90&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ada13f90"]])

export default __exports__